import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacy Policy</h1>
          <p className="text-xl text-red-100">Last updated: January 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-bold mb-4 text-gray-900">Introduction</h2>
            <p className="text-gray-700 mb-6">
              Madilu Retail Private Limited ("IndyaNet," "we," "our," or "us") is committed to protecting your
              privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when
              you visit our website or use our services.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Information We Collect</h2>
            <p className="text-gray-700 mb-4">We may collect information about you in a variety of ways, including:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>
                <strong>Personal Data:</strong> Name, email address, phone number, company name, and other contact
                information you voluntarily provide to us.
              </li>
              <li>
                <strong>Usage Data:</strong> Information about how you access and use our website, including your IP
                address, browser type, and operating system.
              </li>
              <li>
                <strong>Cookies and Tracking Technologies:</strong> We use cookies and similar tracking technologies to
                track activity on our website and enhance user experience.
              </li>
            </ul>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">How We Use Your Information</h2>
            <p className="text-gray-700 mb-4">We use the information we collect for various purposes, including:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>To provide and maintain our services</li>
              <li>To respond to your inquiries and service requests</li>
              <li>To send you technical notices and support messages</li>
              <li>To improve our website and services</li>
              <li>To monitor and analyze usage and trends</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Disclosure of Your Information</h2>
            <p className="text-gray-700 mb-6">
              We may share your information with third parties only in the ways that are described in this Privacy
              Policy. We do not sell, trade, or rent your personal information to third parties.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Data Security</h2>
            <p className="text-gray-700 mb-6">
              We use administrative, technical, and physical security measures to protect your personal information.
              However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot
              guarantee absolute security.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Your Rights</h2>
            <p className="text-gray-700 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
              <li>Access your personal information</li>
              <li>Correct inaccurate or incomplete information</li>
              <li>Request deletion of your personal information</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Cookies</h2>
            <p className="text-gray-700 mb-6">
              We use cookies to analyze website traffic and optimize your website experience. By accepting our use of
              cookies, your data will be aggregated with all other user data. You can control cookies through your
              browser settings.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Changes to This Privacy Policy</h2>
            <p className="text-gray-700 mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new
              Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2 className="text-2xl font-bold mb-4 text-gray-900 mt-8">Contact Us</h2>
            <p className="text-gray-700">
              If you have any questions about this Privacy Policy, please contact us:
            </p>
            <div className="mt-4 text-gray-700">
              <p>
                <strong>Madilu Retail Private Limited</strong>
              </p>
              <p>No.591, 2nd Floor, 14th Main Road, 15th Cross Rd</p>
              <p>4th Sector, HSR Layout, Bengaluru, Karnataka 560102</p>
              <p className="mt-2">
                Phone: <a href="tel:+917411954841" className="text-red-600 hover:text-red-700">+91 7411954841</a>
              </p>
              <p>
                Email: <a href="mailto:support@indyanet.com" className="text-red-600 hover:text-red-700">support@indyanet.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;